// extracted by mini-css-extract-plugin
export default {"container":"Header_container__ogplU","sideItem":"Header_sideItem__Gg1Wo","menuIcon":"Header_menuIcon__MY1di","avatar":"Header_avatar__doqiK"};